import apiClient from './api';

// Service dédié pour récupérer les URLs d'images signées
// service/api/accountImageService.js
export const getAccountImages = async (accountId) => {
    try {
        const response = await apiClient.get(`/api/accountdocuments/${accountId}/documents`);
        const documents = response.data;
        
        // Filtrer uniquement les images (PICTURE et LOGO)
        const images = documents.filter(doc => 
            doc.type === 'PICTURE' || doc.type === 'LOGO'
        );
        
        return images;
    } catch (error) {
        console.error('Erreur lors de la récupération des images:', error);
        throw new Error('Impossible de charger les images');
    }
};

// Fonction utilitaire pour obtenir l'URL d'une image spécifique
export const getAccountImageUrl = async (accountId, imageType = 'auto') => {
    try {
        const images = await getAccountImages(accountId);
        
        if (images.length === 0) return null;
        
        // Si auto, retourne la première image disponible
        if (imageType === 'auto') {
            return images[0].url;
        }
        
        // Sinon, cherche l'image par type
        const image = images.find(img => img.type === imageType);
        return image ? image.url : null;
        
    } catch (error) {
        console.error('Erreur getAccountImageUrl:', error);
        return null;
    }
};
